export default __webpack_public_path__ + "static/media/smile.fec4051d.svg";